var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRecommendIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#recommend_icon_svg__clip0_10632_3220)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.5 11V5.5M1 6.5V10a1 1 0 001 1h6.713a1.5 1.5 0 001.483-1.272l.538-3.5A1.5 1.5 0 009.252 4.5H7.5A.5.5 0 017 4V2.233C7 1.552 6.448 1 5.767 1a.411.411 0 00-.375.244l-1.76 3.96a.5.5 0 01-.457.296H2a1 1 0 00-1 1z",
    stroke: "#000",
    strokeOpacity: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "recommend_icon_svg__clip0_10632_3220"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h12v12H0z"
  })))));
}

export default SvgRecommendIcon;